import * as React from 'react'

export const SquareAlertIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.32031 1.28125C6.69531 0.929688 7.28125 0.929688 7.65625 1.28125L12.7188 6.34375C13.0703 6.71875 13.0703 7.30469 12.7188 7.67969L7.65625 12.7422C7.28125 13.0938 6.69531 13.0938 6.32031 12.7422L1.25781 7.67969C0.90625 7.30469 0.90625 6.71875 1.25781 6.34375L6.32031 1.28125ZM7 4C6.67188 4 6.4375 4.25781 6.4375 4.5625V7.1875C6.4375 7.51562 6.67188 7.75 7 7.75C7.30469 7.75 7.5625 7.51562 7.5625 7.1875V4.5625C7.5625 4.25781 7.30469 4 7 4ZM7.75 9.25C7.75 8.85156 7.39844 8.5 7 8.5C6.57812 8.5 6.25 8.85156 6.25 9.25C6.25 9.67188 6.57812 10 7 10C7.39844 10 7.75 9.67188 7.75 9.25Z"
        fill="#E03A3E"
      />
    </svg>
  )
}
